// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"RichTextParagraph_paragraph__KXSO3","withSpace":"RichTextParagraph_withSpace__HB6m8"};